import { useState } from "react";
import Drawer from "app/shared/UI/Drawer";
import { pageStyles } from "app/shared/UI/Layout/PageStyles";
import PageTitle from "app/shared/UI/Layout/PageTitle";
import PageContent from "app/shared/UI/Layout/PageContent";

const Page = (props) => {
  const {
    hasDrawer,
    drawerComponent,
    drawerIconTooltip,
    pageTitle,
    hasBackButton,
    backButtonTooltip,
    backActionCB,
    contentComponent,
    isDrawerOpen,
  } = props;
  const [openDrawer, setOpenDrawer] = useState(isDrawerOpen || false);

  const handleOpenDrawer = () => {
    setOpenDrawer(() => !openDrawer);
  };

  const DrawerComponent = hasDrawer && drawerComponent ? drawerComponent : null;
  const ContentComponent = contentComponent ? contentComponent : "div";

  return (
    <div style={pageStyles.pageContainer}>
      {hasDrawer && (
        <Drawer openDrawer={openDrawer}>
          {/* STUDY FILTER */}
          <DrawerComponent />
        </Drawer>
      )}
      <div
        style={{
          ...pageStyles.pageMain,
          ...(openDrawer ? pageStyles.pageMainShift : {}),
        }}
      >
        <PageTitle
          hasDrawer={hasDrawer}
          openDrawer={openDrawer}
          toggleDrawer={handleOpenDrawer}
          pageTitle={pageTitle}
          hasBackButton={hasBackButton}
          backButtonTooltip={backButtonTooltip}
          backActionCB={backActionCB}
          drawerIconTooltip={drawerIconTooltip}
        />
        <PageContent>
          {/* STUDY DASHBOARD */}
          <ContentComponent {...props} />
        </PageContent>
      </div>
    </div>
  );
};

export default Page;
